/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DecideStepIn } from '../models/DecideStepIn';
import type { SuccessResponse_DecideStepResult_ } from '../models/SuccessResponse_DecideStepResult_';
import type { SuccessResponse_WorkRequestStepListResponse_ } from '../models/SuccessResponse_WorkRequestStepListResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ApprovalsService {
    /**
     * List Work Request Steps Endpoint
     * GET /api/v1/work_requests/{request_id}/steps — 列出审批步 (审批进度, only-read)。
     *
     * 行级可见性由 RLS p_wrs_select 兜底 (requester / 各步 approver / store scope 管理角色 /
     * system)。读路径不做业务过滤, 仅 RBAC 粗粒度门 + RLS。
     * @returns SuccessResponse_WorkRequestStepListResponse_ Successful Response
     * @throws ApiError
     */
    public static listWorkRequestStepsEndpointApiV1WorkRequestsRequestIdStepsGet({
        requestId,
    }: {
        requestId: number,
    }): CancelablePromise<SuccessResponse_WorkRequestStepListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/work_requests/{request_id}/steps',
            path: {
                'request_id': requestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Decide Step Endpoint
     * POST /api/v1/work_requests/{request_id}/steps/{step_id}/decide — 审批某步 (D6 写)。
     *
     * 防自批 / 防共谋 / 当前审批人校验 / 乐观锁全在
     * service.decide_step (§5.2) + DB 双层兜底; router 只做 RBAC 粗粒度门 + 限流 + envelope。
     * @returns SuccessResponse_DecideStepResult_ Successful Response
     * @throws ApiError
     */
    public static decideStepEndpointApiV1WorkRequestsRequestIdStepsStepIdDecidePost({
        requestId,
        stepId,
        requestBody,
    }: {
        requestId: number,
        stepId: number,
        requestBody: DecideStepIn,
    }): CancelablePromise<SuccessResponse_DecideStepResult_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/work_requests/{request_id}/steps/{step_id}/decide',
            path: {
                'request_id': requestId,
                'step_id': stepId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
